import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material';
import { NewGroupDialogComponent } from '../new-group-dialog/new-group-dialog.component';
import { ManageGroupDialogComponent } from '../manage-group-dialog/manage-group-dialog.component';
import { DeleteGroupDialogComponent } from '../delete-group-dialog/delete-group-dialog.component';
import { RestApiService } from '../shared/restApiServices/restapi.service';
import { DataSource } from '@angular/cdk/table';
import { MatPaginator } from '@angular/material';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { user } from '../classes/userInGroup';
import { LoaderService } from '../shared/services/loader.service'
import { NoGroupService } from '../shared/services/no-group.service'
import { isUndefined } from "util";
import {ToastyService, ToastyConfig, ToastOptions, ToastData} from 'ng2-toasty';
import {TabsDataService} from '../shared/services/tabs-data.service';
import {isNullOrUndefined} from "util";
import { superAdminService } from 'app/shared/services/superAdminService';
import { Router } from '@angular/router';
declare var amplitude:any;


@Component({
  selector: 'app-groups',
  templateUrl: './groups.component.html',
  styleUrls: ['./groups.component.css']
})
export class GroupsComponent implements OnInit {

  newGroupDialogRef: any;
  deleteGroupDialog: any;
  failMsg: string;
  // displayedColumns = ['checkbox','Name', 'NumSurveyers', 'SurveysAssigned', 'CreatedOn','Manage'];
  displayedColumns = ['sno','Name', 'NumSurveyers', 'Manager', 'SurveysAssigned', 'CreatedOn', 'Manage'];
  groupDatabase: GroupDatabase;
  dataSource: GroupDataSource | null;
  manageGroupDialog: any;
  showDelete: boolean;
  checkedRows: string[];
  showLoader: boolean = true;
  noGroupCreated: boolean;
  user: string;
  userHeader: string;
  companyName:string;
  selectedTeam:string;

  switchOrgList:{orgName:string,superAdminID:string}[]=[];
  superAdmin= false;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(public dialog: MatDialog, public restApiService: RestApiService, 
    public loaderService: LoaderService, public noGroupService: NoGroupService,
    private toastyService:ToastyService, private toastyConfig: ToastyConfig, 
    private tabsDataService:TabsDataService, private superAdminService: superAdminService,
    private router:Router) {

    this.showDelete = false;
    this.checkedRows = [];
    // this.loaderService.setLoader(true);
    this.loaderService.getLoader().subscribe(message => {
       if (message != null)
       { this.showLoader = message } 
      });
    this.noGroupService.setNoGroup(false);
    this.noGroupService.getNoGroup().subscribe(message => {
       if (message != null) 
       { this.noGroupCreated = message } 
      });
    this.user = localStorage.getItem("username");
    this.userHeader = localStorage.getItem("user_name_header");
    this.companyName = localStorage.getItem('companyName');
    // checking if it is manager or not..
    if (this.superAdminService.hasData()) {
      this.superAdmin = this.superAdminService.getData();
    } else {
      this.restApiService.checkIfSuperAdmin().subscribe(
        result => {
          if (result.checkIfSuperAdmin == true) {
            this.superAdmin = true;
            this.superAdminService.setData(this.superAdmin);
          }
          else {
            this.superAdmin = false;
            this.superAdminService.setData(this.superAdmin);
          }
        });
    }
  }

  ngOnInit() {

    // this.groupDatabase = new GroupDatabase(this.restApiService, this.loaderService, this.noGroupService,this.tabsDataService);
    this.dataSource = new GroupDataSource(this.groupDatabase, this.paginator);
    this.switchOrgList = this.restApiService.getSwitchOrgList();
    this.noGroupService.setNoGroup(false);
    this.loaderService.setLoader(true);
    this.tabsDataService.setTeamsTabDataTobeUpdated(true);
    this.groupDatabase = new GroupDatabase(this.restApiService, this.loaderService, this.noGroupService,this.tabsDataService);
    this.dataSource = new GroupDataSource(this.groupDatabase, this.paginator);
  }

  onSelectOrg(org:{orgName:string,superAdminID:string}){
    if(org && org.superAdminID && org.superAdminID != undefined && org.orgName && org.orgName){
      localStorage.setItem('superAdminID',org.superAdminID);
      localStorage.setItem('companyName',org.orgName);
      this.companyName = org.orgName;
      // this.restApiService.orgName.next(this.companyName);
      // this.groupDatabase = new GroupDatabase(this.restApiService, this.loaderService, this.noGroupService,this.tabsDataService);
      this.dataSource = new GroupDataSource(this.groupDatabase, this.paginator);
      this.switchOrgList = this.restApiService.getSwitchOrgList();
      this.noGroupService.setNoGroup(false);
      this.loaderService.setLoader(true);
      this.tabsDataService.setTeamsTabDataTobeUpdated(true);
      this.groupDatabase = new GroupDatabase(this.restApiService, this.loaderService, this.noGroupService,this.tabsDataService);
      this.dataSource = new GroupDataSource(this.groupDatabase, this.paginator);
    }
  }
  openSettings(){
    this.router.navigateByUrl('/userProfile');
  }
  searchByName = "";
  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
    this.searchByName = filterValue;
  }

  openCreateGroupDialog() {
    amplitude.getInstance().logEvent('Addnewteambuttonclickedunderteamstab');
    this.newGroupDialogRef = this.dialog.open(NewGroupDialogComponent, {
      height: '560px',
      width: '935px',
    });

    this.newGroupDialogRef.afterClosed().subscribe(result => {

      this.selectedTeam = result.teamName;
      if(result.success!=false)
      {
        this.addToast(true,false);
        this.noGroupService.setNoGroup(false);
        this.loaderService.setLoader(true);
        this.tabsDataService.setTeamsTabDataTobeUpdated(true);
        this.groupDatabase = new GroupDatabase(this.restApiService, this.loaderService, this.noGroupService,this.tabsDataService);
        this.dataSource = new GroupDataSource(this.groupDatabase, this.paginator);
      }

    });
  }

  getNumSurveyers(row) {
    let num = 0;
    let users = row.uIDs;
    let uIds = [];
    if (users && users.length !=0) {
      users.forEach(data=>{
        if(data != null){
          if(!uIds.includes(data)){
            uIds.push(data);
          }
        }
      });
      num = uIds && uIds.length>0?uIds.length:0;
    }
    return num;
  }

  getSurveysAssiged(row) {
    // if (row.qNames && row.qNames.length > 2) {
    //   let surveyNames = '';
    //   surveyNames += row.qNames[0];
    //   surveyNames += ",";
    //   surveyNames += row.qNames[1];
    //   surveyNames += ",";
    //   if (row.qNames.length > 2) {
    //     surveyNames += "...";
    //   }
    //   return surveyNames;
    // }
    // else if (row.qNames && row.qNames.length > 0) {
    //   let surveyNames = '';
    //   for (let i = 0; i < row.qNames.length; i++) {
    //     surveyNames += row.qNames[i];
    //     if (i < row.qNames.length - 1) {
    //       surveyNames += ",";
    //     }
    //   }
    //   return surveyNames;
    // }
    // else
    //   return 'No Survey Assigned';

    if (row.qNames && row.qNames.length == 1) {
      return row.qNames[0];
    }
    else if (row.qNames && row.qNames.length > 1) {
      const survey = row.qNames[0].substring(0,3)+"...";
      return survey;
    }
  }

  hasSurvey(row){
    if (row.qNames && row.qNames.length > 0) {
      return true;
    }
    return false;
  }

  remainingSurvey(row){
    if (row.qNames && row.qNames.length > 1) {
      const count = row.qNames.length - 1;
      return "and "+count+ " more";
    }
  }

  addSurveyor(row,list:boolean){
    if(this.getNumSurveyers(row) ==0){
      // if(!(this.user==row.manager|| row.manager =="Self")){
      //   let toastOptions:ToastOptions = {
      //     title: "Unable to add surveyor",
      //     msg: "You can not Add surveyors for this team as you didn't create this team.",
      //     showClose: true,
      //     timeout: 3000,
      //     theme: 'bootstrap'
      //   };
      //   this.toastyService.warning(toastOptions);
      //   return;
      // }
      this.onManageGroups(row,list);
    }
    else{
      this.viewSurveyor(row);
    }
  }

  addSurvey(row,list:boolean){
    if(!this.hasSurvey(row)){
      // if(!(this.user==row.manager|| row.manager =="Self")){
      //   let toastOptions:ToastOptions = {
      //     title: "Unable to assign survey",
      //     msg: "You can not Assign surveys for this team as you didn't create this team.",
      //     showClose: true,
      //     timeout: 3000,
      //     theme: 'bootstrap'
      //   };
      //   this.toastyService.warning(toastOptions);
      //   return;
      // }
      this.onManageGroups(row,list);
    }
    else{
      this.viewSurvey(row);
    }
  }

  viewSurvey(row){
    row.list = null;
    row.view = "viewSurvey";
    row.qIDs = row.qIDs;
    let team:{id:string,qIds:string[],teamName:string}[] = [];
    let teams:any = this.groupDatabase.data;
    teams.forEach(data=>{
      team.push({id:data.id,qIds:data.qIDs,teamName:data.teamName});
    })
    row.teams = team;
    this.manageGroupDialog = this.dialog.open(ManageGroupDialogComponent, {
      height: '600px',
      width: '88rem',
      data: row
    });
    this.manageGroupDialog.afterClosed().subscribe(response=>{
      //  if user click on assign survey from view survey list (when it has 0 survey)
      if(response && response.assignSurvey && response.index != null){
        let index = response.index
        let row:any = this.groupDatabase.data?this.groupDatabase.data[index]:null;
        // if(!(this.user==row.manager|| row.manager =="Self")){
        //   let toastOptions:ToastOptions = {
        //     title: "Unable to assign survey",
        //     msg: "You can not Assign surveys for this team as you didn't create this team.",
        //     showClose: true,
        //     timeout: 3000,
        //     theme: 'bootstrap'
        //   };
        //   this.toastyService.warning(toastOptions);
        //   return;
        // }
        this.onManageGroups(row,true);
      }
    })
  }

  viewSurveyor(row){
    row.list = null;
    row.view = "viewSurveyor";
    let team:{id:string,qIds:string[],teamName:string}[] = [];
    let teams:any = this.groupDatabase.data;
    teams.forEach(data=>{
      team.push({id:data.id,qIds:data.qIDs,teamName:data.teamName});
    })
    row.teams = team;
    this.manageGroupDialog = this.dialog.open(ManageGroupDialogComponent, {
      height: '600px',
      width: '88rem',
      data: row
    });
    this.manageGroupDialog.afterClosed().subscribe(response=>{
      //  if user click on add surveyor from view surveyor list (when it has 0 surveyor)
      if(response && response.addSurveyor && response.index != null){
        let index = response.index
        let row:any = this.groupDatabase.data?this.groupDatabase.data[index]:null;
        // if(!(this.user==row.manager|| row.manager =="Self")){
        //   let toastOptions:ToastOptions = {
        //     title: "Unable to add surveyor",
        //     msg: "You can not Add surveyors for this team as you didn't create this team.",
        //     showClose: true,
        //     timeout: 3000,
        //     theme: 'bootstrap'
        //   };
        //   this.toastyService.warning(toastOptions);
        //   return;
        // }
        this.onManageGroups(row,false);
      }
    })
  }

  onManageGroups(row,list:boolean) {
    if(list == true )
    {
      amplitude.getInstance().logEvent('Actionsclicked', { "options": "Assign surveyors"});

    }
    else
    {
      amplitude.getInstance().logEvent('Actionsclicked', { "options": "Assign surveys"});
    }
    row.list = list;
    row.view = "manage";
    this.manageGroupDialog = this.dialog.open(ManageGroupDialogComponent, {
      height: '600px',
      width: '88rem',
      data: row
    });
    this.manageGroupDialog.afterClosed().subscribe(result => {
      // this.tabsDataService.setTeamsTabDataTobeUpdated(true);
      this.groupDatabase = new GroupDatabase(this.restApiService, this.loaderService, this.noGroupService,this.tabsDataService);
      this.dataSource = new GroupDataSource(this.groupDatabase, this.paginator);
    });
  }

  deleteGroup(row) {
    amplitude.getInstance().logEvent('Actionsclicked', { "options": "Delete team"});
    this.deleteGroupDialog = this.dialog.open(DeleteGroupDialogComponent, {
      height: '285px',
      width: '400px',
      data: row.id
    });
    this.deleteGroupDialog.afterClosed().subscribe(result => {
      if(result.success==true)
      {
        this.selectedTeam = row.teamName;
        this.addToast(false,true);
        this.tabsDataService.setTeamsTabDataTobeUpdated(true);
        this.groupDatabase = new GroupDatabase(this.restApiService, this.loaderService, this.noGroupService,this.tabsDataService);
        this.dataSource = new GroupDataSource(this.groupDatabase, this.paginator);
      }
    });
  }

  addToast(onAdd : boolean, onDelete : boolean) {
    if(onAdd){
      var toastOptions:ToastOptions = {
        title: "Team Added",
        msg: "Team "+  this.selectedTeam  + ' was successfully added.',
        showClose: true,
        timeout: 3000,
        theme: 'bootstrap'
      };
      this.toastyService.success(toastOptions);
    }else if(onDelete){
      var toastOptions:ToastOptions = {
        title: "Team Deleted",
        msg: "Team "+  this.selectedTeam + ' was successfully deleted.',
        showClose: true,
        timeout: 3000,
        theme: 'bootstrap'
      };
      this.toastyService.success(toastOptions);
    }
  }
}

export interface groupDetail {

  groupName: string,
  "users": user[],
  "adminSurveyIDs": string[],
  "adminSurveyNames": string[],
  "description": string,
  "createdAt": string
}

export class GroupDatabase {
  /** Stream that emits whenever the data has been modified. */
  dataChange: BehaviorSubject<groupDetail[]> = new BehaviorSubject<groupDetail[]>([]);
  get data(): groupDetail[] { return this.dataChange.value; }
  restApiService: RestApiService;
  loaderService: LoaderService;
  noGroupService: NoGroupService;
  tabsDataService:TabsDataService;

  constructor(restApiService: RestApiService, loaderService: LoaderService, noGroupService: NoGroupService,tabsDataService:TabsDataService) {
    // Fill up the database with 100 users.
    this.restApiService = restApiService;
    this.loaderService = loaderService;
    this.noGroupService = noGroupService;
    this.tabsDataService = tabsDataService;

    if(!isNullOrUndefined(this.tabsDataService.getTeamsTabData()) && !this.tabsDataService.hasTeamsTabDataTobeUpdated())
    {
      let groups = this.tabsDataService.getTeamsTabData();
      this.noGroupService.setNoGroup(false);
      this.loaderService.setLoader(false);
      this.dataChange.next(groups);
    }
    else {

      this.restApiService.getGroupListWithDetailsForAdminService(null).subscribe(
        result => {
          // console.log(result);
          if (result == null || isUndefined(result.groups) || result.groups.length == 0) {
            this.loaderService.setLoader(false);
            this.noGroupService.setNoGroup(true);
          }
          else {
            let groups:any = result.groups;
            this.tabsDataService.setTeamsTabData(groups);
            this.tabsDataService.setTeamsTabDataTobeUpdated(false);
            this.noGroupService.setNoGroup(false);
            this.dataChange.next(groups);
            this.loaderService.setLoader(false);
          }
        });
    }
  }

  /** Adds a new user to the database. */
  // addUser(group) {
  //   const copiedData = this.data.slice();
  //   copiedData.push(this.createNewGroup(group));
  //   this.dataChange.next(copiedData);
  // }

  /** Builds and returns a new User. */
  // private createNewGroup(group) {
  //   group['src']= '../../assets/images/check_box_unchecked.svg';
  //   return group;
  // }
}

/**
 * Data source to provide what data should be rendered in the table. Note that the data source
 * can retrieve its data in any way. In this case, the data source is provided a reference
 * to a common data base, ExampleDatabase. It is not the data source's responsibility to manage
 * the underlying data. Instead, it only needs to take the data and send the table exactly what
 * should be rendered.
 */
export class GroupDataSource extends DataSource<any> {
  _filterChange = new BehaviorSubject('');
  get filter(): string { return this._filterChange.value; }
  set filter(filter: string) { this._filterChange.next(filter); }

  constructor(private _exampleDatabase: GroupDatabase, private _paginator: MatPaginator) {
    super();
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<groupDetail[]> {
    const displayDataChanges = [
      this._exampleDatabase.dataChange,
      this._paginator.page,
      this._filterChange,
    ];

    return Observable.merge(...displayDataChanges).map(() => {
      const data = this._exampleDatabase.data.slice();

      // Grab the page's slice of data.
      const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
      const renderedData = data.splice(startIndex, this._paginator.pageSize);
      return renderedData.filter((item: any) => {
        // returning list of data which has teamName as searchStr.
        let searchStr = (item.teamName);
          searchStr = searchStr?searchStr.toLowerCase():'';
        return searchStr.indexOf(this.filter.toLowerCase()) != -1;
      });
    });
  }

  disconnect() { }
}



// WEBPACK FOOTER //
// ./src/app/groups/groups.component.ts